import React, {Component} from 'react';
import './ChatPage.css';
import DocumentTitle from '../widgets/DocumentTitle';
import Chat from './Chat';
import {connect} from 'react-redux';
import chatActions from './chat.actions';
import Avatar from '../widgets/Avatar';
import {Link, Route, Switch} from 'react-router-dom';
import timeSince from '../timeSince';
import EmptyMessage from '../widgets/EmptyMessage';
import FancyButton from '../widgets/FancyButton';
import Spinner from '../widgets/Spinner';
import notificationActions from './notifications.actions.js';

const getPrettyDate = isoString =>
	isoString && timeSince(new Date(Date.parse(isoString)), undefined, false);

export class ChatPage extends Component {
	constructor(props) {
		super(props);

		props.retrieve(); // Get list of most recent chats
	}

	render() {
		const {
			chat: {items, more, retrieving},
			session,
			selectedParticipantUuid,
			retrieveMore
		} = this.props;

		if (!session || !session.user) return null;

		return (
			<DocumentTitle title="B2Me">
				<main className={`ChatPage ${selectedParticipantUuid ? 'open' : 'closed'}`}>
					<section className="ChatPage-people">
						<ol>
							{items && items.length ? (
								items.map(chat => (
									<li
										key={chat.code}
										className={
											chat.participants.find(
												part => (part.user && part.user.uuid) === selectedParticipantUuid
											)
												? 'selected'
												: ''
										}>
										<Link
											to={`/chats/${chat.participants
												.map(part => part.user && part.user.uuid)
												.join(':')}`}
											onClick={() =>
												this.props.dismissChat(
													chat.participants.map(part => part.user && part.user.uuid).join(':')
												)
											}>
											{chat.participants.map(part => (
												<Avatar
													extraClass="ChatPage-people-avatar"
													key={part.user && part.user.uuid}
													size={32}
													backgroundImage={part.profile && part.profile.avatarImage}
												/>
											))}
											<div className="ChatPage-people-details">
												<div className="ChatPage-people-name">
													{chat.participants
														.map(part =>
															part.user && part.user.firstname
																? `${part.user.firstname} ${part.user.lastname}`
																: 'New user'
														)
														.join(', ')}
												</div>
												<div className="ChatPage-people-last">
													{chat.messages.length
														? chat.messages[chat.messages.length - 1].content
														: undefined}
												</div>
											</div>
											<div className="ChatPage-people-time">
												{chat.lastMessage ? getPrettyDate(chat.lastMessage) : timeSince(new Date())}
											</div>
										</Link>
									</li>
								))
							) : retrieving ? (
								undefined
							) : (
								<li className="ChatPage-people-empty">No chats</li>
							)}
							{retrieving ? <Spinner /> : undefined}
							{more && !retrieving ? (
								<li className="ChatPage-people-more">
									<FancyButton onClick={retrieveMore}>Load more...</FancyButton>
								</li>
							) : (
								undefined
							)}
						</ol>
					</section>
					<Switch>
						<Route path="/chats/:uuid" component={Chat} />
						<Route>
							<EmptyMessage>
								Select a chat from the left, or start a new one from a provider's profile page
							</EmptyMessage>
						</Route>
					</Switch>
				</main>
			</DocumentTitle>
		);
	}
}

const ConnectedChatPage = connect(
	(state, ownProps) => ({
		chat: state.chat,
		session: state.session && state.session.current,
		selectedParticipantUuid:
			ownProps && ownProps.match && ownProps.match.params && ownProps.match.params.uuid
	}),
	dispatch => ({
		retrieve: () => dispatch(chatActions.retrieve()),
		retrieveMore: () => dispatch(chatActions.retrieveMore()),
		dismissChat: key => dispatch(notificationActions.dismissChatNotification(key))
	})
)(ChatPage);

export default ConnectedChatPage;



// WEBPACK FOOTER //
// ./src/user/ChatPage.js